import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'gom',
    fullName: 'Konkani',
    nativeName: 'कोंकणी',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "आर्गव्हॉयड हें नांव",
    landing_title: "कितें तरी अद्भुत येवपाचें आसा",
    landing_subtitle: "आर्गव्हॉयड हो अॅप आनी गेम डेव्हलपमेंट स्टुडिओ आसा. पळयत रावात, नवी गजाल बेगीन येतली!",
    select_language: "भास निवडात",
    search_placeholder: "भासो सोदप...",
    terms_title: "सेवा अटी",
    policy_title: "गुप्तताय धोरण",
    cookies_title: "कुकी धोरण",
    terms_content: `
        <strong>1 हें नांव. अटी मान्य करप</strong><br>
        ArgVoid ऍक्सॅस करून, ह्यो सेवा अटी मान्य करतात. जर ह्यो अटी मान्य नात जाल्यार, सेवा वापरूंक फावना.<br><br>

        <strong>2 हें नांव. प्लॅटफॉर्म वापर</strong><br>
        ArgVoid आनी ताचे ऍप्लिकेशनां म्हायती आनी सृजनशील उद्देशां खातीर "आसा तशीं" दिल्यांत. सेवा फकत कायदेशीर उद्देशां खातीर वापरपाक जाय.<br><br>

        <strong>3 हें नांव. प्रतिबंधीत आचरण</strong><br>
        साइट असुरक्षीततायेचो शोशण करप, स्पॅमिंग करप, वा मुळाव्या साधनसुविधांचो अनधिकृत प्रवेशाचो यत्न करप खरपणान बंदी आसा.<br><br>

        <strong>4 हें नांव. अस्वीकरण</strong><br>
        प्लॅटफॉर्म आनी सेवांनी खंयच्याय वेळार कळोवणी दिनासतना बदल करूं येतात. सेवा अपटायम वा उपलब्धताये संबंदी कसलीच हमी दिवंक ना.
    `,
    policy_content: `
        <strong>1 हें नांव. म्हायती एकठांय करप</strong><br>
        प्लॅटफॉर्माक ह्या वेळार वापरप्याचें प्रमाणीकरण वा खातें तयार करपाची गरज ना. खंयचीच वैयक्तीक वळख माहिती (देखीक नांवां वा ईमेल पत्ते) भेट दिवप्यां कडल्यान सक्रियपणान एकठांय केल्ली ना.<br><br>

        <strong>2 हें नांव. वापर डेटा</strong><br>
        साइट येरादारी समजून घेवपाक आनी ऍप्लिकेशनां सुदारपाक मुळावें, अनामिक विश्लेशण एकठांय करूंक शकता. हो डेटा वैयक्तीक वापरप्याच्या वळखीकडेन जोडिल्लो ना.<br><br>

        <strong>3 हें नांव. तिसऱ्या पक्षाची सेवा</strong><br>
        तिसऱ्या पक्षाच्या पुरवणदारांचो होस्टिंग आनी विश्लेशण सेवां खातीर वापरूं येता. ह्या संबंदीत पुरवणदारांची गुप्तताय पद्दत तांच्या मुळाव्या साधनसुविधांचेर प्रक्रिया केल्ल्या अनामिक डेटाचेर नियंत्रण दवरतात.<br><br>

        <strong>4 हें नांव. डेटा सुरक्षा</strong><br>
        प्लॅटफॉर्माची राखण करपा खातीर वाजवी सुरक्षा उपाय चालीक लायतात. पूण इंटरनॅटाचेर प्रसारण करपाची खंयचीच पद्दत पुरायपणान सुरक्षीत ना.<br><br>
    `,
    cookies_content: `
        <strong>1 हें नांव. कुकीज आनी थळावो सांठो म्हणल्यार कितें?</strong><br>
        कुकीज आनी ब्राउझर थळावो सांठो म्हळ्यार भेटींतल्यान संरचना पसंती याद दवरपाक डिव्हायसाचेर सांठयल्लीं ल्हान डेटा फायली.<br><br>

        <strong>2 हें नांव. वापर उद्देश</strong><br>
        ब्राउझर LocalStorage संरचना मांडावळी जतनाय घेवपाक खरपणान वापरतात, जशे की:<br>
        - भास पसंती<br>
        - वापरपी संवाद संरचना (देखीक, मांडावळ वा थीम मांडावळी)<br>
        - तात्पुरतो ऍप्लिकेशन cache<br><br>

        <strong>3 हें नांव. ना ट्रॅकिंग</strong><br>
        कुकीज आनी थळावो साठवण जायराती खातीर वा तिसऱ्या पक्षाच्या ट्रॅकिंग उद्देशां खातीर वापरनात. सगळो सांठयल्लो डेटा खरपणान प्लॅटफॉर्माच्या मुळाव्या कार्यक्षमताय खातीर आसा.<br><br>

        <strong>4 हें नांव. नियंत्रण</strong><br>
        ब्राउझर डेटा ब्राउझर मांडावळी वरवीं खंयच्याय वेळार निवळ करूं येता, जो खंयचीय थळावी संरचना रीसेट करतली.
    `,
    cookie_consent_text: "वेबसायटी योग्य रितीन काम करता हाची खात्री करपाक आमी मुळाव्यो कुकीज वापरतात, जशे की तुमचें सत्र सक्रिय दवरप, तुमची भास पसंती जतनाय घेवप, आनी हेर सानुकूल संरचना.",
    read_policy: "कुकी धोरण वाचात",
    support_title: "आदाराक संपर्क सादचो",
    support_subject_label: "विशय",
    support_message_label: "संदेश",
    support_submit_button: "संदेश धाडचो",
    support_hint: "टिप: हाका लागून संदेश धाडपाक तुमचो मुलभूत ईमेल ऍप्लिकेशन उगडटलो.",
    support_success_msg: "तुमचो ईमेल अॅप उगडप...",
    support_error_msg: "संदेश धाडपाक अपेस आयलें. उपकार करून फुडें परतून यत्न करात.",
    explorer_title: "एक्सप्लोरर",
    history_title: "इतिहास",
    animation_title: "एनिमेशन",
    config_title: "संरचना करप",
    tool_mouse: "(Ctrl+M) निवडात.",
    tool_brush: "ब्रश (Ctrl+B) 1.1.",
    tool_brush_mode: "टॉगल मोड (घन/स्पष्ट) 1.1.",
    tool_eraser: "इरेझर (Ctrl+E) 1.1.",
    tool_brush_size: "ब्रश आकार समायोजित करात",
    tool_bucket: "भरप (Ctrl+F) 1.1.",
    tool_eyedropper: "दोळ्यांचो बूंद",
    tool_grid: "जाळी (Ctrl + शिफ्ट + बी) 1.1.",
    tool_rotate: "घुंवडावप (Ctrl+Shift+R) 1.1.",
    tool_flip_h: "फ्लिप एच (Ctrl + शिफ्ट + एच) 1.1.",
    tool_flip_v: "फ्लिप वी (Ctrl + शिफ्ट + वी) 1.1.",
    tool_transpose: "ट्रान्सपोज (Ctrl + शिफ्ट + टी) 1.1.",
    label_width: "रुंदी",
    label_height: "उंचाय",
    label_frames: "फ्रेमांची संख्या",
    label_animation: "एनिमेशन शैली",
    label_background_color: "पार्श्वभूंय रंग",
    label_interval: "अंतराल",
    tool_anim_config: "एनिमेशन संरचना",
    label_new_width: "नवी रुंदाय",
    label_new_height: "नवी उंचाय",
    label_apply: "लागू करचें",
    label_colors: "रंग",
    label_size: "आकार",
    label_tolerance: "सोंंसप",
    val_horizontal: "आडवें",
    val_vertical: "उबे",
    val_sequence: "अनुक्रम",
    val_bounce: "बाउन्स",
    val_random: "बिनहिशोबी",
    val_solid: "घन",
    val_clear: "नितळ",
    action_add_sheet: "नवें पत्रक",
    action_import: "आयात",
    action_export: "निर्यात",
    action_sort_projects: "वर्गवारी",
    sort_date_old: "सगळ्यांत पोरनो पयली",
    sort_date_new: "सगळ्यांत नवें पयलें",
    sort_name_az: "नांव (अ-झ) 1 .",
    sort_name_za: "नांव (झ-अ) 1 .",
    action_new_sprite: "नवो स्प्राइट",
    action_new_project: "नवो प्रकल्प",
    modal_save_all_title: "सगळे बदल जतनाय घेयात",
    modal_save_all_desc: "जतनाय घेवपाक मालमत्ता निवडात:",
    modal_save_selected: "निवडलेले जतनाय घेयात",
    action_saved: "जतनाय घेतल्या",
    modal_create_sprite_title: "नवो स्प्राइट तयार करचो",
    modal_create_project_title: "नवो प्रकल्प तयार करचो",
    modal_add_sheet_title: "नवें पत्रक जोडचें",
    modal_rename_sheet_title: "पत्रकाचें नांव बदलचें",
    modal_rename_sprite_title: "स्प्राइट हें नांव बदलचें",
    modal_delete_sprite_title: "स्प्राइट काडून उडोवप",
    modal_delete_project_title: "प्रकल्प काडून उडोवप",
    modal_delete_sheet_title: "पत्रक काडून उडोवप",
    placeholder_sprite_name: "नांव",
    placeholder_project_name: "नांव",
    placeholder_sheet_name: "नांव",
    placeholder_new_name: "नवें नांव",
    action_create: "निर्माण करचें",
    action_add: "जमा करचें",
    action_rename: "नांव बदलचें",
    action_duplicate: "डुप्लीकेट करप",
    action_delete: "वगळावचें",
    action_cancel: "रद्द",
    confirm_delete_sprite: "तुमकां हो स्प्राइट काडून उडोवपाचो आसा हाची खात्री आसा?",
    confirm_delete_project: "तुमकां हो प्रकल्प काडून उडोवपाचो आसा हाची खात्री आसा? सगळे स्प्राइट काडून उडयतले.",
    confirm_delete_sheet: "तुमकां हें पत्रक काडून उडोवपाचें आसा हाची खात्री आसा?",
    err_select_sprite: "उपकार करून पयलीं स्प्राइट निवडात.",
    err_select_project: "उपकार करून पयलीं एक प्रकल्प निवडात.",
    err_name_empty: "नांव रितें आसूंक शकना.",
    err_sprite_exists: "त्या नांवाचो स्प्राइट पयलींच अस्तित्वांत आसा.",
    err_project_exists: "त्या नांवाचो प्रकल्प पयलींच अस्तित्वांत आसा.",
    err_no_content: "जतनाय घेवपाक सामुग्री ना.",
    err_no_changes: "जतनाय घेवपाक बदल नात.",
    err_delete_last_sheet: "निमाणें पत्रक काडून उडोवंक मेळना.",
    err_extract_frames: "खंयचीच फ्रेम काडूंक शकली ना.",
    err_indexeddb: "थळाव्यान जतनाय घेवंक अपेस आयलें. तुमचो ब्राउझर IndexedDB चो समर्थन करूंक शकना.",
    msg_upload_success: "अपलोड यशस्वी: {0}",
    msg_upload_failed: "अपलोड अपयशी: {0}",
    msg_save_success: "जतनाय घेवप यशस्वी.",
    msg_saving: "बचत करप...",
    msg_multi_save_result: "{0} मालमत्ता जतनाय घेतल्या. {1} अपेस आयल्यात.",
    menu_title: "मेनू",
    menu_save: "सांबाळचें",
    menu_save_all: "सगळें वाचवचें",
    menu_support: "आदाराक संपर्क सादचो",
    label_local_storage: "थळावो साठवण",
    label_sign_in: "सायन इन करचें",
    modal_export_title: "स्प्राइट निर्यात करप",
    label_filename: "फायलनाव",
    label_format: "स्वरूप",
    action_export_confirm: "निर्यात",
};

export default translations;
